// Provider identity helpers. The mapping lives in src/shared/providers.ts; glyph path data lives in
// src/shared/providerGlyphs.ts so the worker can draw the same marks.

import { normalizeProvider, providerDisplayName, type ProviderId } from "../shared/providers";

export type { ProviderId } from "../shared/providers";
export { providerGlyphs } from "../shared/providerGlyphs";

/** Normalizes a reported provider string ("Claude", "openai", "xAI") to a known provider id, or null when nothing was reported. */
export const providerFromString = normalizeProvider;

export function providerLabel(id: ProviderId | null): string {
  if (!id) return "Declared manually";
  return id === "other" ? "Agent" : providerDisplayName(id);
}
